import { Injectable, ViewContainerRef } from '@angular/core';
import { LMModel } from '@form/model/lm-model';
import { LMActionRequest, LMActionService } from '@services/lm-action.service';
import { LMActionRequestSaveMode } from '@utils/app.constants';

@Injectable()
export class LMFormActionUtilService {
  constructor(private lmActionService: LMActionService) {}

  /**
   * @deprecated use LMActionService.getTargetAction instead
   */
  public getTargetAction(formSpec: LMFormSpec, dataView: LMDataView, action?: string): any {
    return this.lmActionService.getTargetAction({ formSpec, dataView, actionName: action });
  }
}

export interface LMFormContext {
  /**
   * Url info needed to resolve any urls using lm-url-util-service.
   */
  formUrlInfo: LMFormUrlInfo;
  /**
   * Response Required dialog prompt will use the formspec to determine what fields should be displayed.
   */
  formSpec: LMFormSpec;
  /**
   * Response Required updates form model. The audit fields are added back to the Form model.
   * The form model is kept in sync with the dataView. If the user attempts to save after fixing
   * an application error, the response required fields prompt will display the previous values.
   */
  formModel?: LMModel;
  /**
   * Confirmation dialog and Response required fields dialog uses the ViewContainerRef.
   */
  placeholder?: ViewContainerRef;
  /**
   * This is only used by request actions as there are two kinds of save button, draft and submit.
   */
  actionRequestMode?: LMActionRequestSaveMode;
  /**
   * This is set if formSpec.isDependentForm is true. The detail section form will depend on
   * list selection and so the from resource id will be used to set the value.
   */
  sourceResourceId?: string;

  /**
   * Value used to validate captcha
   */
  captchaValue?: string;
  /**
   * Action result after MFA
   */
  stepUpActionResult?: LMActionResult;
}

export interface LMPanelTransactionArgs {
  busClassSpec: LMBusClassSpec,
  transactionUrl: string,
  actionRedirectUrl: string,
  placeholder: ViewContainerRef;
}

/**
 * Information sent by form + additional params
 */
export interface LMFormActionParams {
  observer?: any;
  actionRequestArray?: LMActionRequest[];
  url?: string;
  // From FormContext
  formSpec?: LMFormSpec;
  formModel?: LMModel;
  placeholder?: ViewContainerRef;
  hideToast?: boolean;
}
